import React from 'react';

import { ThemeProvider } from '@mui/material/styles';

import { defaultTheme } from './theme-definition';

// eslint-disable-next-line react/function-component-definition
export const BohThemeProvider = ({ children }) => <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
